import styled, { useTheme } from 'styled-components';

import { Theme } from '../../theme';

interface AtletaLogoProps {
  symbolOnly?: boolean;
  symbolColor?: string;
  textColor?: string;
  height?: number;
}

const AtletaLogo = ({ symbolOnly, symbolColor, textColor, height = 24 }: AtletaLogoProps) => {
  const theme = useTheme() as Theme;

  const symbolHexColor = symbolColor ? theme.getColor(symbolColor) : '#292e69';
  const textHexColor = textColor ? theme.getColor(textColor) : '#292e69';

  const symbolColors = symbolColor ? [
    theme.transparentize(symbolHexColor, 0.45),
    theme.transparentize(symbolHexColor, 0.15),
    theme.transparentize(symbolHexColor, 0.30),
  ] : [
    '#808ac4',
    '#64c2a1',
    '#1fbff2',
  ];

  const viewBox = symbolOnly ? '0 0 141.19 132.52' : '0 0 578.27 132.52';

  const styles = {
    transition: 'all 0.5s ease-in-out',
  };

  return (
    /* eslint-disable max-len */
    <AtletaLogoElement xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} height={height} style={styles}>
      {!symbolOnly && (
        <>
          <path
            d="M238,47.34V125.2H218.61V114.69c-5.33,8.34-16.34,12.18-25.84,12.18-20.51,0-38.35-15.85-38.35-40.69,0-25,17.67-40.51,38.18-40.51,9.84,0,20.68,3.83,26,12V47.34ZM218.28,86c0-13.67-11.34-22.34-22.51-22.34-12,0-21.84,9.33-21.84,22.34s9.83,22.67,21.84,22.67A22.23,22.23,0,0,0,218.28,86Z"
            fill={textHexColor}
            style={styles}
          />
          <path
            d="M302.15,62.84H285.64V125.2H266.3V62.84h-14V47.34h14V18.66h19.34V47.34h16.51Z"
            fill={textHexColor}
            style={styles}
          />
          <path
            d="M316.16,5.65H335.5V125.2H316.16Z"
            fill={textHexColor}
            style={styles}
          />
          <path
            d="M429.7,93H369.51c2.17,10.84,10.51,16.34,22,16.34,8.5,0,16.51-3.34,21.18-9.67l12.83,9.84c-7.17,11.33-20.84,17.34-35,17.34-23.34,0-41-16.34-41-40.69,0-24.84,18.67-40.51,40.84-40.51,22.35,0,39.85,15.5,39.85,39.85A63.8,63.8,0,0,1,429.7,93ZM410.86,79.51c-1.17-10.67-9.33-16.83-20.17-16.83-10.5,0-18.84,5-21.18,16.83Z"
            fill={textHexColor}
            style={styles}
          />
          <path
            d="M485.73,62.84H469.22V125.2H449.88V62.84h-14V47.34h14V18.66h19.34V47.34h16.51Z"
            fill={textHexColor}
            style={styles}
          />
          <path
            d="M572.6,47.34V125.2H553.26V114.69c-5.34,8.34-16.34,12.18-25.84,12.18-20.51,0-38.35-15.85-38.35-40.69,0-25,17.67-40.51,38.18-40.51,9.84,0,20.67,3.83,26,12V47.34ZM552.93,86c0-13.67-11.34-22.34-22.51-22.34-12,0-21.85,9.33-21.85,22.34s9.84,22.67,21.85,22.67A22.24,22.24,0,0,0,552.93,86Z"
            fill={textHexColor}
            style={styles}
          />
        </>
      )}
      <path
        d="M63.25,54.74,121.7,74.13a1.23,1.23,0,0,0,1.45-1.78L92.23,18.79a24.85,24.85,0,1,0-29,36Z"
        fill={symbolColors[0]}
        style={styles}
      />
      <path
        d="M93.73,82.22l-46,40.92a1.23,1.23,0,0,0,.82,2.15h61.83A24.84,24.84,0,1,0,98.15,79,25,25,0,0,0,93.73,82.22Z"
        fill={symbolColors[1]}
        style={styles}
      />
      <path
        d="M54.74,94.94,42.31,34.63A1.23,1.23,0,0,0,40,34.26L9.12,87.81A24.84,24.84,0,1,0,55.36,100.4,25.17,25.17,0,0,0,54.74,94.94Z"
        fill={symbolColors[2]}
        style={styles}
      />
    </AtletaLogoElement>
    /* eslint-enable max-len */
  );
};

export const AtletaLogoElement = styled.svg``;

export default AtletaLogo;
